import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import goldLogo from "../assets/gold-logo.png";
import silverLogo from "../assets/silverRateWork.png";
import { checckCapitalLogin, logoutUser } from "../services/authService";
import CapitalLoginModal from "./common/CapitalLoginModal";

export default function Sidebar({ darkMode, setDarkMode }) {
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const [capitalLoginRequired, setCapitalLoginRequired] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (pathname === "/capital") {
      checkingForCapitalLogin();
    } else {
      setCapitalLoginRequired(false);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  const checkingForCapitalLogin = async () => {
    setChecking(true);
    try {
      const response = await checckCapitalLogin();
      console.log(response);
      if (response) {
        setCapitalLoginRequired(false);
      } else {
        setCapitalLoginRequired(true);
      }
    } catch (err) {
      setCapitalLoginRequired(true);
      console.log("Error occured while checking the capital auth");
    } finally {
      setChecking(false);
    }
  };

  const handleLogout = async () => {
    try {
      logoutUser();
      navigate("/login");
    } catch (error) {}
  };

  return (
    <>
      <div className="sidebar" id="sidebar">
        <div className="logomain d-flex align-items-center justify-content-center">
          <img src={logo} className="img-fluid logo" alt="KW Logo" />
        </div>
        <div className="logoName text-center my-2">
          GOLD &amp; SILVER <br /> Accounting System
        </div>

        <div className="navItems mt-4">
          <div className="navLinks text-start ms-3 mt-5">
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <i className="bi bi-boxes ms-3 me-2 iconSidebar"></i>
              <span>Dashboard</span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/salepoint">
              <i className="fa-solid fa-cart-arrow-down ms-2 me-1 iconSidebar"></i>
              <span> Sale point</span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/gold-rate-work">
              <img
                src={goldLogo}
                className="img-fluid ms-2 me-1 goldIconSidebar"
                alt="gold"
              />
              <span> Gold rate work </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/silver-rate-work">
              <img
                src={silverLogo}
                className="img-fluid ms-2 me-1 goldIconSidebar"
                alt="silver"
              />
              <span> Silver rate work </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/daily-reports">
              <i className="fa-solid fa-clipboard-list ms-2 me-1 iconSidebar"></i>
              <span> Daily Reports </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/customer-manager">
              <i className="fa-solid fa-people-roof ms-2 me-1 iconSidebar"></i>
              <span> Customer Manager </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/inventory">
              <i className="fa-solid fa-file-invoice ms-2 me-1 iconSidebar"></i>
              <span> Inventory </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/openinginventory">
              <i className="fa-solid fa-file-invoice ms-2 me-1 iconSidebar"></i>
              <span> Add Inventory </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/capital">
              <i className="fa-solid fa-coins ms-2 me-1 iconSidebar"></i>
              <span> Capital </span>
            </NavLink>
          </div>

          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/receipt">
              <i className="fa-solid fa-receipt ms-2 me-1 iconSidebar"></i>
              <span> Receipt </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/whatsappreport">
              {/* <i class="fa-brands fa-whatsapp"></i> */}
              <i className="fa-brands fa-whatsapp ms-2 me-1 iconSidebar"></i>
              <span> WhatsApp Report </span>
            </NavLink>
          </div>
          <div className="navLinks text-start ms-3 mt-4">
            <NavLink to="/user-preference">
              <i className="fa-solid fa-gear ms-2 me-1 iconSidebar"></i>
              <span> User Preference </span>
            </NavLink>
          </div>

          <div className="extra" style={{ marginTop: "5rem" }}></div>

          {/* <div className="navLinks text-start ms-3 mt-4">
          <NavLink to="/help-center">
            <i className="fa-regular fa-circle-question ms-2 me-1 iconSidebar"></i>
            <span> Help Center </span>
          </NavLink>
        </div> */}

          {/* Dark Mode Toggle */}
          <div className="navLinks text-start ms-3 mt-4">
            <p className="darkmode d-flex align-items-center gap-2 mb-0">
              <i className="fa-solid fa-circle-half-stroke iconSidebar"></i>
              <span style={{ color: "#fff" }}>Dark Mode</span>
              <input
                type="checkbox"
                id="checkboxInput"
                checked={darkMode}
                onChange={() => setDarkMode(!darkMode)}
              />
              <label
                htmlFor="checkboxInput"
                className="toggleSwitch mb-0"
              ></label>
            </p>
          </div>

          {/* Logout */}
          <div
            className="navLinks text-start ms-3 mt-4"
            style={{ cursor: "pointer" }}
          >
            <div
              onClick={handleLogout}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "12px 15px",
                borderRadius: "8px",
                transition: "0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#c0392b")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <i
                className="fa-solid fa-right-from-bracket ms-2 me-1"
                style={{ color: "silver" }}
              ></i>
              <span style={{ color: "#fff" }}> Logout </span>
            </div>
          </div>

          <div className="extra" style={{ marginBottom: "2rem" }}></div>
        </div>
      </div>

      <CapitalLoginModal
        show={capitalLoginRequired}
        onSuccess={() => setCapitalLoginRequired(false)}
        checking={checking}
      />
    </>
  );
}
